import {AfterViewInit, Directive, ElementRef, Input, OnChanges, Renderer2, SimpleChanges} from '@angular/core';
import {TranslationService} from "@spartacus/core";
import {EbProductTypeEnum} from "../../interfaces/eb-product.interface";

@Directive({
    selector: '[ebTruncateText]',
    standalone: false
})
export class EbTruncateTextDirective implements AfterViewInit, OnChanges{

  @Input() productType: EbProductTypeEnum;

  MAX_LINES = 10
  readMoreButton : any;
  readLessButton : any;

  constructor(
    private elementRef: ElementRef,
    private renderer: Renderer2,
    private translationService: TranslationService
  ){
    this.readMoreButton = this.renderer.createElement('button');
    this.readLessButton = this.renderer.createElement('button');
  }
  ngAfterViewInit(): void {
    const element = this.elementRef.nativeElement as HTMLElement;

    if (this.productType === EbProductTypeEnum.PARENT) {
      this.checkHeight(element);
    }
  }

  ngOnChanges(changes: SimpleChanges) {
    if(this.productType === EbProductTypeEnum.VARIANT){
      this.readMoreButton.style.display = 'none';
      this.readLessButton.style.display = 'none';
      this.elementRef.nativeElement.style.maxHeight = null;
    }
    else{
      this.checkHeight(this.elementRef.nativeElement)
    }
  }

  checkHeight(element: HTMLElement){
    const lineHeight = parseInt(window.getComputedStyle(element).lineHeight, 10)
    const maxHeight = this.MAX_LINES * lineHeight;

    if (element.clientHeight > maxHeight && this.productType === EbProductTypeEnum.PARENT) {
      this.renderer.setStyle(element, 'maxHeight', `${maxHeight}px`);
      this.renderer.setStyle(element, 'overflow', 'hidden');
      this.addReadMoreButton(element);
    }
  }

  addReadMoreButton(element: HTMLElement): void {
    this.readMoreButton.style.display = 'block'
    this.translationService.translate('productDetail.showMore').subscribe(translation => {
      this.renderer.setProperty(this.readMoreButton, 'textContent', translation);
    })
    this.renderer.listen(this.readMoreButton, 'click', () => {
      element.style.maxHeight = null;
      this.readMoreButton.style.display = 'none';
      this.addReadLessButton(element);
    });
    this.renderer.appendChild(element.parentElement, this.readMoreButton);
  }

  addReadLessButton(element: HTMLElement): void {
    this.readLessButton.style.display = 'block'
    this.translationService.translate('productDetail.showLess').subscribe(translation => {
      this.renderer.setProperty(this.readLessButton, 'textContent', translation);
    })
    this.renderer.listen(this.readLessButton, 'click', () => {
      const lineHeight = parseInt(window.getComputedStyle(element).lineHeight, 10);
      const maxHeight = this.MAX_LINES * lineHeight;
      if (element.clientHeight > maxHeight) {
        this.renderer.setStyle(element, 'maxHeight', `${maxHeight}px`);
        this.renderer.setStyle(element, 'overflow', 'hidden');
        this.addReadMoreButton(element);
        this.readLessButton.style.display = 'none';
      }
    });
    this.renderer.appendChild(element.parentElement, this.readLessButton);
  }
}

